import React from "react";
import { CustomLinearProgressTop } from "./loading/Progress.jsx";
import { ServiceErrorAlert } from "./Error.jsx";
import { TurnrActionAlert } from "./alerts/TurnrAlert.jsx";
import { serviceIsLoading, serviceIsSuccessfullyFetched } from "rylak-common";
import ShopSelect from "./input/selects/ShopSelect.jsx";
import { getBrandName } from "../cores/brandCore";

export default function BrandOrMerchantNeededWrapper({ appProps, children, alertProps }) {
    const { brandService, selectedBrandId, selectedMerchantId } = appProps;
    const hasScope = selectedBrandId || selectedMerchantId;
    return (
        <>
            <ServiceErrorAlert serviceData={brandService} {...alertProps} />
            {serviceIsLoading(brandService) ? (
                <CustomLinearProgressTop />
            ) : !hasScope ? (
                <>
                    <TurnrActionAlert variant="outlined" {...alertProps}>
                        Please select a <b>Shop</b> or <b>Shop Group</b> to view this page
                    </TurnrActionAlert>
                    {appProps && (
                        <div style={{ marginTop: "20px" }}>
                            <ShopSelect
                                appProps={appProps}
                                value={selectedBrandId}
                                onChange={appProps?.setSelectedBrandId}
                                selectNoneComponent={"All Shops"}
                                title={"Select shop"}
                                loading={false}
                                fullWidth={false}
                                renderSelected={(option) => {
                                    return getBrandName(option?.brand) || "-";
                                }}
                            />
                        </div>
                    )}
                </>
            ) : selectedBrandId ? (
                serviceIsSuccessfullyFetched(brandService) && children
            ) : (
                children
            )}
        </>
    );
}
